import React from 'react';
import HtmlPart from '../parts/HtmlPart';

function PopOverToolTip({ content, show, position = 'top' }) {
  if(!show) return null;
  return (
    <div className={`c-popover--${position}`}>
      <div className="c-popover__inner u-padding-small u-border-box">
        <HtmlPart htmlString={content} />
        <span className="c-popover__triangle--bottom-left" />
      </div>
    </div>
  );
}

export default PopOverToolTip;



// WEBPACK FOOTER //
// ./src/layout/PopOverToolTip.js